import { BriefcaseEyeOutlineIcon } from './BriefcaseEyeOutlineIcon';

/**
 * author: Andrej Sharapov
 * id 6C1979BB-3BFD-4466-9934-945FAB608E90
 * name briefcase-eye-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-eye-outline.svg
 * tags
 */
export const BriefcaseViewOutlineIcon = BriefcaseEyeOutlineIcon;
export default BriefcaseViewOutlineIcon